module.exports = __webpack_public_path__ + "img/logo_transparent.c8e168ce.png";